import { MutationTree } from 'vuex'
import { PipelineConnectionsState } from './index'
import { PipelineConnection } from '@/api/model/pipeline-connection'

export const mutations: MutationTree<PipelineConnectionsState> = {
    loadPipelineConnections(state: PipelineConnectionsState): void {
        state.loading = true
        state.loaded = false
        state.error = null
    },

    loadPipelineConnectionsSuccess(state: PipelineConnectionsState, payload: {incomingConnections: PipelineConnection[], outgoingConnections: PipelineConnection[] }): void {
        state.loading = false
        state.loaded = true
        state.error = null
        state.incomingConnections = payload.incomingConnections
        state.outgoingConnections = payload.outgoingConnections
    },

    loadPipelineConnectionsFailure(state: PipelineConnectionsState, message: string): void {
        state.loading = false
        state.loaded = false
        state.error = message
    },
}
